import dayjs from 'dayjs';

import type { AvailabilityDatesInterface } from '@valk-nx/availability-dates-store/availability-dates.interface';

export function generateVhiAvailability(
	startDate: string,
	endDate: string,
): AvailabilityDatesInterface {
	const availability: AvailabilityDatesInterface = {};
	let arrival = dayjs(startDate);
	const end = dayjs(endDate);

	while (!arrival.isAfter(end)) {
		const arrivalKey = arrival.format('YYYY-MM-DD');
		const departures: Record<string, Record<string, never>> = {};

		let departure = arrival.add(1, 'day');
		while (!departure.isAfter(end)) {
			departures[departure.format('YYYY-MM-DD')] = {};
			departure = departure.add(1, 'day');
		}

		if (Object.keys(departures).length > 0) {
			availability[arrivalKey] = departures;
		}

		arrival = arrival.add(1, 'day');
	}

	return availability;
}
